module.exports = __webpack_public_path__ + "media/images/front/top/tarlige-72bd2bc770771a3c92c80b54b556e755.png";